module.exports = __webpack_public_path__ + "assets/28db6c6713b881929e425504384f6bc8.svg";